import React from 'react';
import { Link } from 'react-router-dom';
import ExperienceGrid from '../components/site/ExperienceGrid';
import CaseStudies from '../components/site/CaseStudies';
import WhoWeWorkWith from '../components/site/WhoWeWorkWith';
import HowItWorks from '../components/site/HowItWorks';
import Faq from '../components/site/Faq';
import { AudienceIntro, BlanksSection, FulfillmentSection, MinimumsSection } from '../components/site/ProductionSections';
import { PageHero, PageShell, QuoteBand, QuoteButton } from '../components/site/PageParts';
import useSeo from '../hooks/useSeo';

const PROCESS = [
  { title: 'Quote', text: 'Tell us what you want made — products, decoration, quantity and deadline. We reply within one business day.' },
  { title: 'Design & mockups', text: 'We prepare your artwork for production and send a mockup showing colors, sizes and placements for your approval.' },
  { title: 'Samples', text: 'Want to hold it before the full run? Samples are available on request.' },
  { title: 'Production', text: 'Your order is produced in-house at our Los Angeles / Orange County facilities. Typical turnaround is 7–10 days.' },
  { title: 'Quality check', text: 'Every order is checked before it leaves our facility.' },
  { title: 'Packing', text: 'Your order is packed and prepared for delivery, retail or storage.' },
  { title: 'Delivery or fulfillment', text: 'We ship nationwide, or store your stock and ship orders to your customers as they come in.' },
];

export default function Production() {
  useSeo({
    title: 'Merch Production & Manufacturing in Los Angeles | Pusha Teez',
    description:
      'Full-service merch production in Los Angeles / Orange County: screen printing, embroidery, DTG & DTF, cut and sew and fulfillment. Low minimums, 7–10 day turnaround, nationwide shipping.',
    path: '/production',
  });
  return (
    <PageShell testid="production-page">
      <PageHero
        eyebrow="Merch production & manufacturing"
        title="Full-Service"
        accent="Merch Production"
        intro="Pusha Teez produces merch in-house in Los Angeles / Orange County — screen printing, embroidery, DTG & DTF, sublimation, cut and sew and fulfillment under one roof. Minimums are low — none on most techniques — typical turnaround is 7–10 days and we ship nationwide, so a band's first run and a company's next rollout get the same care."
        img="https://customer-assets.emergentagent.com/job_pusha-rebrand/artifacts/94j66qvq_4.JPG"
      >
        <div className="mt-10"><QuoteButton testid="production-hero-quote-btn" /></div>
      </PageHero>
      <ExperienceGrid
        title="What we"
        accent="produce"
        intro="Every technique is done in-house. Choose one to learn more, or tell us about your project and we'll recommend the right method for your design, garment and budget — bold screen prints for big runs, embroidery for a premium finish, DTG and DTF for full-color detail, or cut and sew for garments built from scratch."
      />
      <WhoWeWorkWith>
        <AudienceIntro />
      </WhoWeWorkWith>
      <HowItWorks
        title="Our"
        accent="process"
        steps={PROCESS}
        intro="The same seven steps for every order, from a single sample to a full production run, so you always know what happens next."
      />
      <MinimumsSection />
      <BlanksSection />
      <FulfillmentSection />
      <CaseStudies kind="production" title="Recent production" accent="work" limit={3} moreLink={{ to: '/work', label: 'See all work' }} />
      <p className="max-w-[1500px] mx-auto px-6 -mt-6 pb-8 text-[#cfc8bb] text-base md:text-lg" data-testid="production-work-note">
        A few designs we&apos;ve produced for artists and brands. Browse the full archive — production and live printing — on our{' '}
        <Link to="/work" className="text-[#00b8ff] hover:underline">Work page</Link>.
      </p>
      <Faq />
      <QuoteBand title="Ready to start production?" />
    </PageShell>
  );
}
